/**
 * Route guards.
 *
 * ProtectedRoute — requires an authenticated session.
 * RoleRoute      — additionally requires one of the given roles.
 * These are UX guards; the backend independently enforces every action.
 */
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '@/app/providers/AuthProvider';

function Loader() {
	return (
		<div className="flex min-h-screen items-center justify-center bg-[#0b1120] text-slate-400">
			Caricamento sessione…
		</div>
	);
}

export function ProtectedRoute() {
	const { loading, isAuthenticated } = useAuth();
	const location = useLocation();
	if (loading) return <Loader />;
	if (!isAuthenticated) return <Navigate to="/login" state={{ from: location }} replace />;
	return <Outlet />;
}

/** @param {{roles: string[]}} props */
export function RoleRoute({ roles }) {
	const { loading, isAuthenticated, user } = useAuth();
	if (loading) return <Loader />;
	if (!isAuthenticated) return <Navigate to="/login" replace />;
	if (roles && !roles.includes(user.role))
		return <Navigate to="/admin" replace />;
	return <Outlet />;
}
